import { GetterTree } from 'vuex'

import { RootState } from '@/store/types'

import { PaymentMethodsState } from './types'

const getters: GetterTree<PaymentMethodsState, RootState> = {
  getPaymentMethods({ paymentMethods }) {
    return paymentMethods
  },
}

export default getters
